import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { packagesData } from '../data/content';

const Packages = () => {
  return (
    <div className="pt-24 pb-20 bg-slate-50 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-slate-800 mb-4">精選套裝行程</h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            20 週年【鯨夏一跳】全面優惠價中！提供多種組合滿足您的旅遊需求，帶您深度體驗龜山島之美。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {packagesData.map((pkg, index) => (
            <motion.div
              key={pkg.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-shadow flex flex-col md:flex-row"
            >
              <div className="md:w-2/5 h-64 md:h-auto relative">
                <img 
                  src={pkg.image} 
                  alt={pkg.title} 
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-4 left-4 bg-orange-500 text-white text-xs font-bold px-3 py-1 rounded-full">
                  {pkg.subtitle}
                </div>
              </div>
              
              <div className="p-6 md:w-3/5 flex flex-col justify-between">
                <div>
                  <h3 className="text-2xl font-bold text-slate-800 mb-2">{pkg.title}</h3>
                  <p className="text-slate-600 mb-4 text-sm leading-relaxed">{pkg.desc}</p>
                  
                  <ul className="space-y-2 mb-6">
                    <li className="flex items-center text-sm text-slate-700">
                      <SafeIcon name="Clock" className="text-blue-500 mr-2" />
                      行程時間：{pkg.duration}
                    </li>
                    <li className="flex items-center text-sm text-slate-700">
                      <SafeIcon name="Calendar" className="text-blue-500 mr-2" />
                      航班時段：{pkg.time}
                    </li>
                  </ul>
                </div>
                
                <a 
                  href="tel:0910071850"
                  className="block w-full text-center bg-blue-50 hover:bg-blue-100 text-blue-600 font-semibold py-3 rounded-lg transition-colors border border-blue-200"
                >
                  來電詢問優惠價
                </a>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-16 bg-orange-50 rounded-2xl p-8 border border-orange-100 flex flex-col md:flex-row items-center justify-between">
          <div className="mb-6 md:mb-0 md:mr-8">
            <h4 className="text-xl font-bold text-orange-800 mb-2 flex items-center">
              <SafeIcon name="AlertCircle" className="mr-2" />
              登島注意事項
            </h4>
            <p className="text-orange-700">
              因暑假期間參加人數眾多，提早 30 天報名才可以確保登島證之申請。星期三不開放一般遊客登島，敬請留意行程安排。
            </p>
          </div>
          <a 
            href="tel:0912588105" 
            className="flex-shrink-0 bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 rounded-full font-bold transition-colors shadow-md"
          >
            專人諮詢
          </a>
        </div>

      </div>
    </div>
  );
};

export default Packages;